// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "payment".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { paymentStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "payment" table (1:1 with a DB row, on the wire). */
export const paymentAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    leadId: z.string().nullable(),
    amountCents: z.number(),
    currency: z.string(),
    status: z.enum(paymentStatusValues),
    description: z.string().nullable(),
    stripeCheckoutSessionId: z.string().nullable(),
    stripePaymentIntentId: z.string().nullable(),
    stripeConnectedAccountId: z.string(),
    checkoutUrl: z.string().nullable(),
    customerEmail: z.string().nullable(),
    customerName: z.string().nullable(),
    metadata: z.unknown().nullable(),
    expiresAt: z.string().datetime().nullable(),
    paidAt: z.string().datetime().nullable(),
    refundedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=payment.js.map